import { useLocation } from 'react-router-dom';
import { isPrivatePath } from './privatePaths';

/** True while the router is on a signed-in-only route. */
export function useIsPrivatePath(): boolean {
    const { pathname } = useLocation();
    return isPrivatePath(pathname);
}
